import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGenericProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .05,
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 19.5,
			stroke: "#111"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0zm-5 8a8.632 8.632 0 0 1 6.582 3.037L28 26.619A10.626 10.626 0 0 0 20 23c-3.188 0-6.048 1.4-8 3.62l1.418 1.417A8.632 8.632 0 0 1 20 25z",
			fill: "#111"
		})
	]
});
export default SvgGenericProfile;
